import React, { useState } from 'react';
import logo from "./logo.png";
import { Link } from 'react-router-dom';
import {ImSearch} from 'react-icons/im';
import {GiHamburgerMenu} from 'react-icons/gi';
const Header = () => {
  const [showMediaicons,setShowMediaicons] = useState(false); 
  return (
    <nav className="header">
        <img src={logo} alt="logo" />
        <div className={ showMediaicons ? "mobile-navbar" : "navbar" }>
          <Link to="/#">TV Shows</Link>
          <Link to="/#">Movies</Link>
          <Link to="/#">Recently Added</Link>
          <Link to="/#">My List</Link>
        </div>
          <div className='search'>
            <input type={'text'} />
            <ImSearch/>
            
        </div>
        <div className='hamburger-menu'>
          <Link to="/#" onClick={()=>setShowMediaicons(!showMediaicons)} ><GiHamburgerMenu style={{fontSize:"1.5rem"}}/></Link>
        </div> 
    </nav>
  )
}

export default Header